export default "__VITE_ASSET__bcb099b8__"